import { AttributionModel as AttributionDistribution } from "@redotech/crdb-enums/attribution/attribution-model";
import { AttributionScope } from "@redotech/redo-attribution-common/attribution-scope";
import { attributionRowsSchema } from "@redotech/redo-marketing-common/attribution";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getAttribution = {
  name: "getAttribution" as const,
  input: z
    .object({
      groupBy: z
        .array(z.enum(AttributionScope))
        .describe("Scopes to group on; empty rolls up to one team total"),
      filter: z
        .partialRecord(z.enum(AttributionScope), z.array(z.string()))
        .optional()
        .describe(
          "Ids each scope must take; narrows the rows, not how credit is assigned",
        ),
      distribution: z
        .enum(AttributionDistribution)
        .optional()
        .describe(
          "How to split credit; defaults to the settings' defaultDistribution",
        ),
      from: zExt.instant().describe("Start instant, inclusive"),
      to: zExt.instant().describe("End instant, exclusive"),
    })
    .refine((input) => Temporal.Instant.compare(input.from, input.to) < 0, {
      message: "from must be before to",
    }),
  output: attributionRowsSchema,
};
